import { render, staticRenderFns } from "./ModalDeleteSubLearningOutcome.vue?vue&type=template&id=a8e0bb80&scoped=true&"
import script from "./ModalDeleteSubLearningOutcome.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteSubLearningOutcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e0bb80",
  null
  
)

export default component.exports